<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

  <div>
    <div id="init-help-container" class="mt-3 d-flex" style="width: 100%">
      <v-spacer></v-spacer>
      <v-main>
        <div id="help-container" style="max-width: 768px">
          <div class="c8 doc-content">
            <!-- <p class="c5">
              <span class="c3">Traffic Stats App User Documentation:</span>
            </p> -->
            <h3>
              <span class="c3">Traffic Stats App User Documentation:</span>
            </h3>

            <p class="c5 c6"><span class="c3"></span></p>
            <p class="c5"><span class="c3">Add New Entry: </span></p>
            <p class="c5">
              <span class="c0"
                >The Add Entry Expandable can be found at the top of the web
                app. You can use this to add a new report to the database which
                can be accessed later. The expandable contains the following
                fields which are used to add information to the report.</span
              >
            </p>
            <p class="c5"><span class="c0">&nbsp;</span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0 start">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Type: This field allows you to select which type of report
                  you want to make from the following options: traffic, warrant,
                  dispatch, and complaints.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Details: This is where you type in any specifics that are
                  important to the entry.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Check boxes: Below the details are the following check boxes:
                  Cities, Stops, CFS, Arrest, DUI, Accident, SRO, and MAIT. Use
                  them to add relevant categories to the entry that can be used
                  to help search for it later and to make it easier to quickly
                  determine the type of entry it is.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Location: Here you can add in the location relating to the
                  report. You can either type it in manually or you can have it
                  autofill with the first location you click on when using the
                  Map button (see below).
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Map Button: Clicking this button will bring up a map centered
                  on your current location (you may need to hit
                  &quot;allow&quot; on a pop-up for the map to open to your
                  location). Click the location on the map which is relevant to
                  the report to show where you are reporting on. If you did not
                  fill out the &quot;Location&quot; field previously then the
                  field will be automatically filled with the first location you
                  clicked on (Note that if you click on the wrong spot and have
                  to change the location on the map you will have to change the
                  &quot;Location&quot; field manually). When you are finished
                  with it, hit the done button in the bottom right corner of the
                  map pop-up to complete storing the coordinates you supplied.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Save: Hitting this button will complete your entry and save
                  it to the database.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_qdg6wq6bfu3c-0">
              <li class="c2 li-bullet-0">
                <span class="c0"
                  >Reset Form: Hitting this button will clear all information
                  from your entry, allowing you to quickly start over.
                </span>
              </li>
            </ul>
            <p class="c5 c6"><span class="c0"></span></p>
            <p class="c5 c6"><span class="c3"></span></p>
            <p class="c5 c6"><span class="c3"></span></p>
            <p class="c5 c6"><span class="c3"></span></p>
            <p class="c5"><span class="c3">Search: </span></p>
            <p class="c5">
              <span class="c0"
                >This expandable can be used to search for entries which already
                exist. It includes the following fields.
              </span>
            </p>
            <p class="c5 c6"><span class="c0"></span></p>
            <ul class="c4 lst-kix_mv35lkz6qym8-0 start">
              <li class="c2 li-bullet-0">
                <span class="c7">From Date and To Date: </span
                ><span class="c0"
                  >These two fields are used to determine the range of dates
                  that the reports you search for will come from. The
                  &ldquo;From Date&rdquo; field is the earliest date the report
                  can come from and the &ldquo;To Date&rdquo; is the latest date
                  the report can come from.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_mv35lkz6qym8-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Type: </span
                ><span class="c0"
                  >This field allows you to select the type of report you would
                  like to search for.</span
                >
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_mv35lkz6qym8-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Checkboxes: </span
                ><span class="c0"
                  >These allow you to select from the set of categories that a
                  report you are searching for should have.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_mv35lkz6qym8-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Search: </span
                ><span class="c0"
                  >This button will cause your search to begin and the Search
                  Results expandable (see below) will be opened, which will
                  contain the results from your search.</span
                >
              </li>
            </ul>
            <p class="c5 c6"><span class="c0"></span></p>
            <p class="c5"><span class="c3">Search Results: </span></p>
            <p class="c5">
              <span class="c0"
                >This expandable appears after a successful search with each
                result that matches your search. You will be able to see all of
                the details of each report that appears within this expandable,
                as well as use the following features:
              </span>
            </p>
            <p class="c5 c6"><span class="c0"></span></p>
            <ul class="c4 lst-kix_buoardoew9h9-0 start">
              <li class="c2 li-bullet-0">
                <span class="c7">Send to Report: </span
                ><span class="c0"
                  >Clicking this button will allow you to print the report, the
                  report&rsquo;s map information, or download the report. You
                  can change which of these things you are doing by selecting
                  from a drop down menu found to the right of this button.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_buoardoew9h9-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Edit: </span
                ><span class="c0"
                  >Using this button will bring up the Edit Entry expandable
                  which will appear at the top of the page, allowing you to
                  update a report or replace incorrect information (more details
                  below under &ldquo;Edit Entry&rdquo;).
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_buoardoew9h9-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Delete: </span
                ><span class="c0"
                  >Using this button allows you to erase a report.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_buoardoew9h9-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Remove From Results: </span
                ><span class="c0"
                  >Using this button will remove a report from your current
                  search results.</span
                >
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_buoardoew9h9-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Map: </span
                ><span class="c0"
                  >Using this button will bring up the map data attached to a
                  report.
                </span>
              </li>
            </ul>
            <p class="c5 c6"><span class="c0"></span></p>
            <p class="c5 c6"><span class="c3"></span></p>
            <p class="c5"><span class="c3">Edit Entry: </span></p>
            <p class="c5">
              <span class="c0"
                >When you click on the &ldquo;Edit&rdquo; button in either the
                Search Results or the Recent (see below) expandables this
                expandable will open up and replace the Add Entry expandable at
                the top of the web app. This expandable functions very similarly
                to the Add Entry expandable, with the following changes:
              </span>
            </p>
            <p class="c5 c6"><span class="c0"></span></p>
            <ul class="c4 lst-kix_khbdk5w2opfi-0 start">
              <li class="c2 li-bullet-0">
                <span class="c7">Save: </span
                ><span class="c0"
                  >Clicking on save will change the entry you are editing to
                  reflect the changes you have made instead of making a new one.
                  This will also get rid of the Edit Entry expandable and bring
                  back the Add Entry expandable.
                </span>
              </li>
            </ul>
            <p class="c1"><span class="c0"></span></p>
            <ul class="c4 lst-kix_khbdk5w2opfi-0">
              <li class="c2 li-bullet-0">
                <span class="c7">Cancel: </span
                ><span class="c0"
                  >This button replaces the &ldquo;Reset Form&rdquo; button from
                  the Add Entry expandable. Using it will cancel your edit and
                  bring back the Add Entry expandable.
                </span>
              </li>
            </ul>
            <p class="c5 c6"><span class="c0"></span></p>
            <p class="c5">
              <span class="c7">Recent: </span
              ><span class="c0"
                >This expandable displays reports from most recent to least
                recent. When you find a report under this expandable you can do
                everything you could with it that you could when finding it
                under the Search Results expandable, with the exception of using
                the &ldquo;Send to Report&rdquo; and &ldquo;Remove From
                Results&rdquo; features.
              </span>
            </p>
          </div>
        </div>
      </v-main>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rename",
  mixins: [bus_common],
  data: function () {
    return {
      item: "fish",
    };
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {},
  },
  mounted() {
    this.$nextTick(() => {
      this.show_loader(false);
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>

<style scoped>
@import url(https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI);

@media (min-width: 0) {
  .lst-kix_khbdk5w2opfi-6 > li:before {
    content: "\0025cf   ";
  }
  ul.lst-kix_buoardoew9h9-4 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-3 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-2 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-1 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-8 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_buoardoew9h9-8 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-7 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-5 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_buoardoew9h9-6 {
    list-style-type: none;
  }
  ul.lst-kix_buoardoew9h9-5 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-6 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-7 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-4 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-5 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_khbdk5w2opfi-4 > li:before {
    content: "\0025cb   ";
  }
  ul.lst-kix_mv35lkz6qym8-2 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-3 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-0 {
    list-style-type: none;
  }
  ul.lst-kix_mv35lkz6qym8-1 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-3 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-4 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_khbdk5w2opfi-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-3 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_khbdk5w2opfi-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_mv35lkz6qym8-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_mv35lkz6qym8-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_buoardoew9h9-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_buoardoew9h9-4 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_buoardoew9h9-3 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_buoardoew9h9-6 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-6 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_mv35lkz6qym8-5 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_buoardoew9h9-5 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_mv35lkz6qym8-7 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_mv35lkz6qym8-8 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_buoardoew9h9-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_buoardoew9h9-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_qdg6wq6bfu3c-0 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_qdg6wq6bfu3c-1 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_qdg6wq6bfu3c-2 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_qdg6wq6bfu3c-3 > li:before {
    content: "\0025cf   ";
  }
  ul.lst-kix_qdg6wq6bfu3c-8 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-6 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-7 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-4 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-5 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-2 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-3 {
    list-style-type: none;
  }
  .lst-kix_buoardoew9h9-7 > li:before {
    content: "\0025cb   ";
  }
  ul.lst-kix_qdg6wq6bfu3c-0 {
    list-style-type: none;
  }
  ul.lst-kix_qdg6wq6bfu3c-1 {
    list-style-type: none;
  }
  .lst-kix_buoardoew9h9-8 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_khbdk5w2opfi-3 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-4 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-1 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-2 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-7 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-8 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-5 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-6 {
    list-style-type: none;
  }
  ul.lst-kix_khbdk5w2opfi-0 {
    list-style-type: none;
  }
  li.li-bullet-0:before {
    margin-left: -18pt;
    white-space: nowrap;
    display: inline-block;
    min-width: 18pt;
  }
  .lst-kix_qdg6wq6bfu3c-8 > li:before {
    content: "\0025a0   ";
  }
  .lst-kix_qdg6wq6bfu3c-6 > li:before {
    content: "\0025cf   ";
  }
  .lst-kix_qdg6wq6bfu3c-7 > li:before {
    content: "\0025cb   ";
  }
  ul.lst-kix_mv35lkz6qym8-8 {
    list-style-type: none;
  }
  .lst-kix_qdg6wq6bfu3c-4 > li:before {
    content: "\0025cb   ";
  }
  .lst-kix_qdg6wq6bfu3c-5 > li:before {
    content: "\0025a0   ";
  }
  ul.lst-kix_buoardoew9h9-0 {
    list-style-type: none;
  }
  .lst-kix_khbdk5w2opfi-7 > li:before {
    content: "\0025cb   ";
  }
  ol {
    margin: 0;
    padding: 0;
  }
  table td,
  table th {
    padding: 0;
  }
  .c2 {
    margin-left: 36pt;
    padding-top: 0pt;
    padding-left: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c1 {
    margin-left: 36pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left;
    height: 11pt;
  }
  .c0 {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Roboto";
    font-style: normal;
  }
  .c3 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Roboto";
    font-style: normal;
  }
  .c5 {
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .c7 {
    font-size: 12pt;
    font-family: "Roboto";
    font-weight: 700;
  }
  .c8 {
    background-color: #ffffff;
    max-width: 768px;
    padding: 10px;
    margin-top: 18px;
  }
  .c4 {
    padding: 0;
    margin: 0;
  }
  .c6 {
    height: 11pt;
  }
  .title {
    padding-top: 0pt;
    color: #000000;
    font-size: 26pt;
    padding-bottom: 3pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  .subtitle {
    padding-top: 0pt;
    color: #666666;
    font-size: 15pt;
    padding-bottom: 16pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  li {
    color: #000000;
    font-size: 11pt;
    font-family: "Arial";
  }
  p {
    margin: 0;
    color: #000000;
    font-size: 11pt;
    font-family: "Arial";
  }
  h1 {
    padding-top: 20pt;
    color: #000000;
    font-size: 20pt;
    padding-bottom: 6pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h2 {
    padding-top: 18pt;
    color: #000000;
    font-size: 16pt;
    padding-bottom: 6pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h3 {
    padding-top: 16pt;
    color: #434343;
    font-size: 14pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h4 {
    padding-top: 14pt;
    color: #666666;
    font-size: 12pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h5 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
  h6 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Arial";
    line-height: 1.15;
    page-break-after: avoid;
    font-style: italic;
    orphans: 2;
    widows: 2;
    text-align: left;
  }
}

@media (min-width: 768px) {
  .c8 {
    background-color: #ffffff;
    max-width: 768px;
    padding: 72pt 72pt 72pt 72pt;
    margin-top: 18px;
  }
}
</style>
